module.exports = __webpack_public_path__ + "img/b401d2b.png";